import { ForgotPasswordPhoneRequest, OtpType, ResponseCode } from '@ul/api';

export const forgotPasswordMockEmail = (email: String) => {
    switch (email) {
        case 'error@mock.com':
            return Promise.resolve({
                success: false,
                responseCode: ResponseCode.ErrorOccurred,
            });
        default:
            return Promise.resolve({
                success: true,
                responseCode: ResponseCode.Successful,
            });
    }
};

export const forgotPasswordMockPhone = (request: ForgotPasswordPhoneRequest) => {
    switch (request.credentials.username) {
        case '+6620012345':
            return Promise.resolve({
                success: false,
                responseCode: ResponseCode.ErrorOccurred,
            });
        case '+6630012345':
            return Promise.resolve({
                success: false,
                responseCode: ResponseCode.UsernameNotFound,
            });
        default:
            if (!!request.otpVerifyInfo) {
                if (request.otpVerifyInfo.code === '000000') {
                    return Promise.resolve({
                        success: false,
                        responseCode: ResponseCode.OtpVerificationFailed,
                    });
                }
            } else {
                return Promise.resolve({
                    success: false,
                    responseCode: ResponseCode.NeedOtp,
                    otpViewModel: {
                        target: request.credentials.username,
                        token: '12345',
                        otpType: OtpType.Phone,
                    },
                });
            }
            break;
    }

    return Promise.resolve({
        success: true,
        responseCode: ResponseCode.Successful,
        token: 'otp-token-12345',
    });
};
